(function() {
  "use strict";
      
  /**
  * Easy selector helper function
  */
  const select = (el, all = false) => {
  el = el.trim()
  if (all) {
    return [...document.querySelectorAll(el)]
  } else {
    return document.querySelector(el)
  }
  }
  
  const primaryMainMenu = {
  init: function () {
  this.focusMenuWithChildren();
  },
  
  // The focusMenuWithChildren() function implements Keyboard Navigation in the Primary Menu
  // by adding the '.focus' class to all 'li.menu-item-has-children' when the focus is on the 'a' element.
  focusMenuWithChildren: function () {
  // Get all the link elements within the primary menu.
  var links,
    i,
    len,
    menu = document.querySelector('.primary-nav-menu');
  
  if (!menu) {
    return false;
  }
  
  links = menu.getElementsByTagName('a');
  
  //let subMenu = document.getElementsByClassName('submenu-expand');
  let subMenu = document.querySelectorAll('.primary-nav-menu .sub-menu-button');
  for (let n = 0; n < subMenu.length; n++) {
    subMenu[n].setAttribute('tabIndex', '-1');
  }
  
  // Each time a menu link is focused or blurred, toggle focus.
  for (i = 0, len = links.length; i < len; i++) {
    links[i].addEventListener('focus', toggleFocus, true);
    links[i].addEventListener('blur', toggleFocus, true);
  }
  
  //Sets or removes the .focus class on an element.
  function toggleFocus() {
    var self = this;
  
    // Move up through the ancestors of the current link until we hit .primary-menu.
    while (-1 === self.className.indexOf('primary-nav-menu')) {
      // On li elements toggle the class .focus.
      if ('li' === self.tagName.toLowerCase()) {
        if (-1 !== self.className.indexOf('focus')) {
          self.className = self.className.replace(' focus', '');
        } else {
          self.className += ' focus';
        }
      }
      self = self.parentElement;
    }
  }
  },
  }; // primaryMenu
  
  
  /*-----------------------------------------------------------------------------------------------
  Activate Keyboard Navigation in the Primary Menu 
  ------------------------------------------------------------------------------------------------- */
  primaryMainMenu.init();
  
  // Hide menu on background click
  function clickHideMenu() {
  let modal = document.querySelectorAll('.site-header__desktop-nav .site-nav___dropdown');
  if(modal.length > 0) {
      modal.forEach( dropdown => {
          dropdown.addEventListener('click', function(e) {
              e.stopPropagation();
              dropdown.classList.add('in-active');
              setTimeout(()=> {
                  dropdown.classList.remove('in-active')
              },100)
          })
        
              
          
      })
  }
  }
  
  // Maybe perform the function on window resize.

       // Toggle mobile menu child list display
       let subMenu = document.querySelectorAll('#navbarCollapse .sub-menu-button');
       if (subMenu.length > 0) {

           let i;
           for (i = 0; i < subMenu.length; i++) {
               subMenu[i].removeAttribute('tabIndex');
               subMenu[i].addEventListener('click', function (event) {
                   event.preventDefault();
                   this.classList.toggle('active');
                   this.parentNode.classList.toggle("is-active");
                   let panel = this.parentNode.nextElementSibling;
                   panel.classList.toggle("active-panel");
                                   
               });
           }
       }
  
  }) ();